import { useQuery } from 'react-query';
import { getApplicationFile } from './downloadApplicationFile';

export const useApplicationFilePreview = ({ applicationID, fileID }) => {
  return useQuery(
    ['job-ad-application-file-preview', applicationID, fileID],
    () => getApplicationFile({ applicationID, fileID }),
    {
      initialData: { url: '', name: '', mime_type: '' },
      enabled: !!fileID,
      select: ({ url, name, mime_type: mimeType = '' }) => ({ url, name, mimeType }),
    }
  );
};
